import React from "react";
import ReactQuill from "react-quill";
import { useParams } from "react-router-dom";
import axios from "axios";
import moment from "moment";
import { toast } from "react-toastify";
import backendService from "../services.js/backendService";
import "react-toastify/dist/ReactToastify.css";
import { useBeforeunload, Beforeunload } from "react-beforeunload";
import toastProp from "../global/toastProps";
import SearchQuestionHeader from "../components/SearchQuestionHeader";
import EditorToolbar, { modules, formats } from "../components/EditorToolbar";
import { useNavigate } from "react-router-dom";
import { PencilAltIcon, SaveIcon, XCircleIcon } from "@heroicons/react/outline";
import ReactTooltip from "react-tooltip";
import { ShimmerPostDetails } from "react-shimmer-effects";

function QuestionPage() {
  const { qid } = useParams();
  const navigate = useNavigate();
  const [question, setQuestion] = React.useState(null);
  const [body, setBody] = React.useState("");
  const [loginid, setLoginid] = React.useState(
    backendService.getLoggedInUser()?._id
  );
  
  const [search, setSearch] = React.useState("");
  const [loading, setLoading] = React.useState(true);
  const [questionBody, setQuestionBody] = React.useState("");
  const [isEditing, setIsEditing] = React.useState(false);
  const [answerBody, setAnswerBody] = React.useState("");
  const [isAnsweringEdititng, setIsAnsweringEditing] = React.useState(false);
  const updateQuestion = async () => {
    await axios
      .put(
        `${process.env.REACT_APP_URL}/updatequestion/${qid}`,
        { body: questionBody },
        { headers: { "x-auth-token": backendService.getToken() } }
      )
      .then((res) => {
        toast.success("Question updated successfully");

        // setIsEditing(false);
        setTimeout(() => {
          window.location.reload(false);
        }, 500);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getQuestion = async () => {
    setLoading(true);
    await axios
      .get(`${process.env.REACT_APP_URL}/getquestion/${qid}/${loginid}`)
      .then((res) => {
        setQuestion(res.data.question);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  React.useEffect(() => {
    getQuestion();
  }, [qid]);

  const submitAnswer = async () => {
    const id = toast.loading("Please wait...", { theme: "light" });
    await axios
      .post(
        `${process.env.REACT_APP_URL}/sendanswer`,
        { body: body, questionId: qid },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      )
      .then((res) => {
        toast.update(id, toastProp("Answer Sent", true));
        window.location.reload(false);
      })
      .catch((err) => {
        toast.update(id, toastProp("Error Sending Answer", false));
      });
  };
  const updateAnswer = async (id) => {
    const id1 = toast.loading("Please wait...", { theme: "light" });
    await axios
      .put(
        `${process.env.REACT_APP_URL}/updateanswer/${id}`,
        { body: answerBody },
        {
          headers: {
            "Content-Type": "application/json",
            "x-auth-token": backendService.getToken(),
          },
        }
      )
      .then((res) => {
        toast.update(id1, toastProp("Answer Updated", true));
        window.location.reload(false);
      })
      .catch((err) => {
        toast.update(id1, toastProp("Error Updating Answer", false));
      });
  };

  const getSearch = (data) => {
    setSearch(data);
  };

  return (
    <div className="h-screen">
      {/* search header */}
      <SearchQuestionHeader getSearch={getSearch} />
      {loading ? (
        <div className=" flex justify-center overflow-hidden chat__container ">
          <div className="w-[80%]">
            <ShimmerPostDetails card cta variant="EDITOR" />
          </div>
        </div>
      ) : (
        <div className="h-[90%] overflow-x-hidden overflow-y-auto chat__container">
          {/* title area */}
          <div className="min-h-[10vh] sm:min-h-0 py-4 sm:py-6 md:py-8 px-4 sm:px-6 md:px-8 lg:px-12 xl:px-20 flex items-center ">
            <div>
              <h3 className="text-xl sm:text-2xl  ">{question?.title}</h3>
              <div className="flex flex-wrap">
                <h3 className="text-sm text-palette_color1">
                  Asked: {moment(question?.createdAt).fromNow()}
                </h3>
                <h3 className="text-sm pl-6 text-palette_color1">
                  Views: {question?.views?.length} times
                </h3>
                {question?.createdAt !== question?.updatedAt && (
                  <h3 className="text-sm pl-6">
                    Modified: {moment(question?.updatedAt).fromNow()}
                  </h3>
                )}
              </div>
            </div>
          </div>
          {/* question area */}
          <div className="w-full flex justify-center ">
            <div className="w-full px-2 sm:w-11/12 md:w-10/12 lg:w-9/12 xl:w-8/12 mx-auto">
              {/* Question */}
              <div className=" mb-4 ">
                <div className="relative ">
                  {" "}
                  {isEditing && <EditorToolbar />}
                  <ReactQuill
                    className={
                      search.length > 0 ? "h-auto !-z-10 relative " : "h-auto"
                    }
                    theme="snow"
                    placeholder={"Write here..."}
                    modules={
                      isEditing
                        ? modules
                        : {
                            toolbar: false,
                          }
                    }
                    formats={formats}
                    onChange={(value) => {
                      
                      setQuestionBody(value);
                    }}
                    value={isEditing ? questionBody : question?.body}
                    readOnly={!isEditing}
                  />
                  {loginid === question?.user._id && (
                    <>
                      {" "}
                      {isEditing ? (
                        <>
                          {" "}
                          <button
                            className="absolute right-2 bottom-2  hover:text-palette_color1"
                            data-tip="Edit"
                            data-place="right"
                            onClick={() => {
                              setIsEditing(false);
                            }}
                          >
                            <XCircleIcon className="h-5 w-5" />
                          </button>
                          <button
                            className="absolute right-10 bottom-2  hover:text-palette_color1 "
                            data-tip="Edit"
                            data-place="right"
                            onClick={async () => {
                              await updateQuestion();
                            }}
                          >
                            <SaveIcon className="h-5 w-5" />
                          </button>
                        </>
                      ) : (
                        <button
                          className="absolute right-2 bottom-2  hover:text-palette_color1"
                          data-tip="Edit"
                          data-place="right"
                          onClick={() => {
                            setIsEditing(true);
                            setQuestionBody(question?.body);
                          }}
                        >
                          <PencilAltIcon className="h-5 w-5"></PencilAltIcon>
                        </button>
                      )}
                    </>
                  )}
                </div>
                <div className="flex flex-wrap text-palette_color1 cursor-pointer">
                  {question.tags.map((tag) => (
                    <h3
                      className="pl-2" /* Padding can be adjusted or handled by space-x on parent if preferred */
                      onClick={() => {
                        navigate(`/forum/${tag}`);
                      }}
                    >
                      {"#" + tag}{" "}
                    </h3>
                  ))}
                </div>
                <div className="flex justify-end mb-1">
                  <h3 className="text-xs text-palette_color1">
                    Asked by: {question?.user.username}{" "}
                    {moment(question?.createdAt).fromNow()}
                  </h3>
                </div>
              </div>
              {/* Answer */}
              <h3 className="text-2xl mb-4">
                {question?.answers.length} Answers
              </h3>
              {question?.answers.length === 0
                ? // <h3 className="text-xl mb-4">No Answers Yet</h3>
                  null
                : question?.answers.map((answer) => (
                    <div className="mb-4 border-b-[1px] border-gray-300">
                      <ReactTooltip delayShow={500} delayHide={100} />
                      <div className=" relative">
                        {" "}
                        {isAnsweringEdititng === answer._id && (
                          <EditorToolbar />
                        )}
                        <ReactQuill
                          className={
                            search.length > 0
                              ? "h-auto !-z-10 relative "
                              : "h-auto"
                          }
                          theme="snow"
                          placeholder={"Write here..."}
                          modules={
                            isAnsweringEdititng === answer._id
                              ? modules
                              : {
                                  toolbar: false,
                                }
                          }
                          formats={formats}
                          onChange={(value) => {
                            
                            setAnswerBody(value);
                          }}
                          value={
                            isAnsweringEdititng === answer._id
                              ? answerBody
                              : answer?.body
                          }
                          readOnly={isAnsweringEdititng !== answer._id}
                        />
                        {loginid === answer.user._id && (
                          <>
                            {" "}
                            {isAnsweringEdititng === answer._id ? (
                              <>
                                {" "}
                                <button
                                  className="absolute right-2 bottom-2  hover:text-palette_color1"
                                  data-tip="Edit"
                                  data-place="right"
                                  onClick={() => {
                                    setIsAnsweringEditing(null);
                                  }}
                                >
                                  <XCircleIcon className="h-5 w-5" />
                                </button>
                                <button
                                  className="absolute right-10 bottom-2  hover:text-palette_color1 "
                                  data-tip="Edit"
                                  data-place="right"
                                  onClick={async () => {
                                    await updateAnswer(answer._id);
                                  }}
                                >
                                  <SaveIcon className="h-5 w-5" />
                                </button>
                              </>
                            ) : (
                              <button
                                className="absolute right-2 bottom-2  hover:text-palette_color1"
                                data-tip="Edit"
                                data-place="right"
                                onClick={() => {
                                  setIsAnsweringEditing(answer._id);
                                  setAnswerBody(answer?.body);
                                }}
                              >
                                <PencilAltIcon className="h-5 w-5"></PencilAltIcon>
                              </button>
                            )}
                          </>
                        )}
                      </div>
                      <div className="flex justify-end my-1">
                        <h3 className="text-xs text-palette_color1">
                          Answered by: {answer?.user.username}{" "}
                          {moment(answer?.createdAt).fromNow()}
                        </h3>
                      </div>
                    </div>
                  ))}
              {/* replay */}
              <div>
                <h3 className="text-2xl mb-2">Your Answer</h3>
                <div>
                  <EditorToolbar />
                  <ReactQuill
                    className="h-auto"
                    theme="snow"
                    placeholder={"Write here..."}
                    modules={modules}
                    formats={formats}
                    onChange={(value) => {
                      setBody(value);
                    }}
                  />
                </div>
                <div className="flex justify-end">
                  <button
                    className="py-2 px-4 sm:py-3 sm:px-6 rounded-md shadow-sm my-2 font-semibold bg-palette_color1 hover:opacity-90 antialiased hover:subpixel-antialiased text-white"
                    onClick={() => {
                      if (!backendService.isLoggedIn()) {
                        navigate("/login", {
                          state: { redirect: "/question/" + qid },
                        });
                      }
                      if (body.length > 0) {
                        submitAnswer();
                      }
                    }}
                  >
                    Post your Answer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
export default QuestionPage;
